import { IInitialReportIssue } from './models'

export const initialData: IInitialReportIssue = {
  subject: '',
  description: '',
  attachments: [],
}

export const QBR_REPORT_FORM_KEY = 'QBR_REPORT_FORM_KEY'

export const FORM_FOR_SAVING_ATTACHMENTS = 1073
export const FORM_CODE_ATTACHMENTS = 'JBPPartnerAttachments'
export const ATTACHMENT_FIELD_NAME = 'Attachment'
export const ATTACHMENT_TYPE = 'QBRReportIssue'
